import { render, staticRenderFns } from "./BodyDashboard.vue?vue&type=template&id=02854864&"
import script from "./BodyDashboard.vue?vue&type=script&lang=js&"
export * from "./BodyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BodyDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports